/** Slug for the storefront homepage CMS page (served at `/`, not `/{slug}`). */
export const HOME_PAGE_SLUG = 'home'

/** Default body when no homepage CMS content exists (shortcodes). */
export const DEFAULT_HOME_PAGE_BODY = `[trust-badges]
[category-grid columns="4"]
[product-carousel title="New Arrivals" subtitle="Discover our latest additions" count="8"]`
